/*************************************/
/*********** U25/U30 types ***********/
/*************************************/

export const OfferSearchView = {
  U25: 'U25',
  U30: 'U30',
}

export const OfferSearchDetailTypes = {
  NO_CHILDREN: 'NO_CHILDREN',
  ONE_CHILDREN: 'ONE_CHILDREN',
  MANY_CHILDREN: 'MANY_CHILDREN',
}

/*************************************/
/****** OfferSearchFilter types ******/
/*************************************/

// Possible filter types
export const OfferSearchFilterTypes = {
  TOPIC_CATEGORIES: 'topic_categories',
  TOPICS: 'topics',
  EVENT_TYPES: 'event_types',
  AUDIENCES: 'audiences',
  PERIOD: 'period',
  STATE_NOT: 'state_not',
  SORTING: 'sorting',
  ONLINE_TYPE: 'online_type',
}

// Filters which get rendered in accordions
export const OfferSearchAccordionFilters = [
  { type: OfferSearchFilterTypes.TOPIC_CATEGORIES, title: 'Themen' },
  { type: OfferSearchFilterTypes.TOPICS, title: 'Themen' },
  { type: OfferSearchFilterTypes.EVENT_TYPES, title: 'Veranstaltungsart' },
  { type: OfferSearchFilterTypes.AUDIENCES, title: 'Zielgruppe' },
  { type: OfferSearchFilterTypes.PERIOD, title: 'Zeitraum' },
]

/*************************************/
/************ Y073 types *************/
/*************************************/

export const Y073SearchVariant = {
  REDIRECT: 'redirect', // if Y073 is used as jump to offer search
  FULL_SEARCH: 'fullSearch', // if Y073 is used on offer search page
}

export const Y073Variant = {
  MEDIUM: 'medium',
  LARGE: 'large',
}

/*************************************/
/************ OfferSearchTile types **/
/*************************************/

export const OfferSearchTileTypes = {
  MACRO: 'macro',
  OFFER_SEARCH: 'offer-search',
}
